/**
 * Not Found Page
 *
 * Displayed when a signature/form link is invalid or not found.
 */
import { FileQuestion, ArrowLeft } from 'lucide-react';
import { Button, Card, CardContent } from '@respectly/ui';
import { PortalLayout } from '../layouts/PortalLayout';

interface NotFoundPageProps {
  type?: 'document' | 'form';
}

export function NotFoundPage({ type = 'document' }: NotFoundPageProps) {
  return (
    <PortalLayout>
      <div className="flex flex-1 items-center justify-center p-4">
        <Card className="w-full max-w-md">
          <CardContent className="p-8 text-center">
            <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-gray-100">
              <FileQuestion className="h-10 w-10 text-gray-500" />
            </div>

            <h1 className="text-2xl font-bold text-gray-900">Not Found</h1>

            <p className="mt-3 text-gray-600">
              {type === 'document'
                ? "We couldn't find this signature request. The link may be invalid or the request may have been removed."
                : "We couldn't find this form. The link may be invalid or the form may no longer be available."}
            </p>

            <div className="mt-4 rounded-lg bg-gray-50 p-4 text-sm text-gray-600">
              <p className="font-medium">Common reasons:</p>
              <ul className="mt-2 list-inside list-disc text-left">
                <li>The link may have been mistyped</li>
                <li>The request may have been cancelled</li>
                <li>The link may have been revoked</li>
              </ul>
            </div>

            <div className="mt-8">
              <Button
                variant="outline"
                className="w-full"
                onClick={() => window.close()}
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Close this page
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </PortalLayout>
  );
}
